<template>
  <div 
    class="moow-master-container play-background"
    v-loading.fullscreen="loading" element-loading-text="Saving Data ..." element-loading-spinner="el-icon-loading">
    <nav-basic :progress="40" title="Start with the basics"></nav-basic>
    <div class="container">
      <b-row class="step-header">
        <p class="moow-header">About the building</p>
      </b-row>
      <b-row>
        <b-col md="6" cols="12">
          <md-card class="island-card pr-3">
            <md-card-content>
            <b-row>
              <b-col xl="6" lg="6" md="12">
                <p class="input-header">General Area</p>
                <md-field :class="{'md-invalid': generalAreaErr}" class="moow-input">
                  <md-input placeholder="m²" v-model="techDet.generalArea" type="number"></md-input>
                  <span class="md-error">{{generalAreaErr}}</span>
                  <span class="md-helper-text">required</span>
                </md-field>
              </b-col>
            </b-row>

            <b-row>
              <b-col xl="6" lg="6" md="12">
                <p class="input-header">Living Area</p>
                <md-field class="moow-input">
                  <md-input placeholder="m²" v-model="techDet.livingArea" type="number"></md-input>
                </md-field>
              </b-col>
            </b-row>

            <b-row>
              <b-col  xl="6" lg="6" md="12">
                <p class="input-header">Bulding Year</p>
                <md-field class="moow-input">
                  <md-input placeholder="YYYY" v-model="techDet.buildingYear" type="number"></md-input>
                </md-field>
              </b-col>
            </b-row>
            <hr class="hr-form-el-separator">

            <b-row>
              <b-col  xl="6" lg="6" md="12">
                <p class="input-header">Condition</p>
                <b-form-select class="moow-input" v-model="techDet.condition" :disabled="disabled" :options="condition" :state="conditionNoError"></b-form-select>
                <p class="input-hint">required</p>
              </b-col>
            </b-row>

            <b-row>
              <b-col  xl="6" lg="6" md="12">
                <p class="input-header">Building Material</p>
                  <b-form-select class="moow-input" v-model="techDet.buildingMat" :options="buildingMaterial"></b-form-select>
              </b-col>
            </b-row>

            <b-row>
              <b-col  xl="6" lg="6" md="12">
                <p class="input-header">Energy Label</p>
                <b-form-select class="moow-input" v-model="techDet.buildingEnLable" :options="energyLabel"></b-form-select>
              </b-col>
            </b-row>
            <hr class="hr-form-el-separator">

            <b-row>
              <b-col>
                <p class="input-header mb-2">Heatings</p>
                <b-row>

                <b-col class="mb-1" md="4" v-for="sub in heatingsList" :key="sub.value">
                    <b-form-checkbox :value="sub.value" v-model="techDet.heatings">{{sub.text}}</b-form-checkbox>
                </b-col>
                </b-row>
              </b-col>
            </b-row>

          </md-card-content>
        </md-card>
                       <b-row class="step-navigator-buttons">
              <b-col style="text-align:left;padding:0">
                <md-button @click="prev()" class="md-primary">
                  <md-icon>arrow_back</md-icon>Back
                </md-button>
              </b-col>
              <b-col style="text-align:right;padding:0">
                <md-button @click="next" class="md-primary play-cta-button makeup">Next</md-button>
              </b-col>
            </b-row>
        </b-col>
        <b-col md="5" offset-md="1">
          <md-card>
            <md-card-header>
                <div class="automated-fields-icon"></div>
            </md-card-header>

            <md-card-content>
              <p>Some of the fields throughtout this process are filled automatically based on the data from EHR (Estonian Building Registry).
              </p>
              <p>Double check to make sure the data is correct.</p>
            </md-card-content>
          </md-card>
        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>
  // import {
  //   conditionList,
  //   readinessList,
  //   heatingsTypeList,
  //   energyLabelList,
  //   buildingMaterialList
  // } from '../lists.js'
const lists = require("@/lists.js");

  import {
    updateListingParts
  } from '../listingFunctions.js'
  import axios from 'axios'
  export default {
    name: 'basic4',
    data() {
      return {
        conditionNoError: null,
        generalAreaErr: "",
        loading: false,
        condition: lists.conditionList,
        energyLabel: lists.energyLabelList,
        buildingMaterial: lists.buildingMaterialList,
        heatingsList: lists.heatingsTypeList
      }
    },
    created() {
      this.techDet.areaSizeUnit='m2'
      if(!this.$store.getters.basic4Visited &&
        this.$store.getters.genDet.propType.superType != 'land') this.populateFieldsFromEhrData(JSON.parse(sessionStorage.getItem('buildingServiceData')))
      // else the computed properties are used without any alteration from ehr data
    },
    computed: {
      techDet() {
        return this.$store.getters.techDet
      },
      disabled() {
        if (this.$store.getters.genDet.propType.superType == 'land') {
          return true
        } else return false
      }
    },
    methods: {
      populateFieldsFromEhrData(bData){
        if(bData && bData.techDet){
          bData.techDet.structureMats?this.techDet.buildingMat = this.mapStructureMatToBuildingMat(bData.techDet.structureMats):void 0;
          bData.techDet.extRoofCovers?this.techDet.buildingRoofType=bData.techDet.extRoofCovers[0]:void 0;
          bData.techDet.energyLable?this.techDet.buildingEnLable=bData.techDet.energyLable:void 0;
        }
        if(bData && bData.genDet){
          bData.genDet.yearIntoUse?this.techDet.buildingYear=bData.genDet.yearIntoUse:void 0;
        }
        if(bData && bData.parts[0]){
          bData.parts[0].totalArea&&bData.parts[0].totalArea!=0?this.techDet.livingArea=bData.parts[0].totalArea:void 0;
          bData.parts[0].totalArea&&bData.parts[0].totalArea!=0?this.techDet.generalArea=bData.parts[0].totalArea:void 0;
        }
      },
      mapStructureMatToBuildingMat(structureMats){
        if(structureMats.includes("modularRC") || structureMats.includes("monolithicRC")) return "concrete"
        if(structureMats.includes("stone")) return "stone"
      },
      leavePage(from, to){
        this.$store.dispatch('visitPage', from);
        this.$router.push({
          name: to
        })
      },
      notifyError(title, msg){
        this.$notify({
          title: title,
          message: msg
        })
      },
      next(evt) {
          if (this.validateForm()) {
            this.save()
            this.leavePage('BASIC4', 'basic5')
          }
      },
      prev() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$store.commit('UPDATE_TECHDET', this.techDet)
            this.leavePage('BASIC4', 'basic3')
          } else {
            this.notifyError('Cannot Update', 'Something is wrong')
          }
        })
      },
      validateForm(){
        var res = true;
        if(!this.techDet.generalArea) {
          this.generalAreaErr = "Required field"
          res = false;
        }else this.generalAreaErr = ""

        if(!this.techDet.condition){
          this.conditionNoError = false
          res = false;
        }else this.conditionNoError = null
        return res;
      },
      saveAndExit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
            this.leavePage('BASIC4', 'dashboard')
          } else {
            this.notifyError('Notification', 'Something is missing')
          }
        })
      },
      save(){
        this.$store.commit('UPDATE_TECHDET', this.techDet)
        updateListingParts(this.createUpdateParts())
          .catch(err => {})
      },
      createUpdateParts(){
        return{
          'techDet': this.techDet
        }
      }
    },
    props: {
      data: {
        type: Object,
        required: false
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/styles/add-steps.css';
  @import '../assets/styles/global.css';

  #desc {
    background-color: rgb(240, 229, 229);
  }

  .checkBtn {
    opacity: 0;
    outline: none;
    position: absolute;
    margin: 0;
    left: -999px;
  }

  .button {
    margin: 10px;
    width: 150px;
    height: 40px;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #1f8efa;
    border-radius: 4px;
    border: solid 1px #1f8efa;
    background-color: #ffffff
  }

  p {
    color: #757575;
    text-align: left;
    font-size: 14px;
  }


  .form-group {
    margin-bottom: 0px;
  }

  label {
    float: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/basic4.vue